import http from 'plugins/axios';

export default {
  getConfList({ confType, searchWords }) {
    let u = confType == 'r' ? '/admin/siteconf/getRedis' : '/admin/siteconf/get';
    return http.get({
      url: u,
      data: {
        key: searchWords,
        page:1,
        size:1000
      }
    });
  },
  updateConf({ confType, k, v }) {
    let u = confType == 'r' ? '/admin/siteconf/updateRedis' : '/admin/siteconf/update';
    return http.post({
      url: u,
      data: {
        key: k,
        value: v
      },
      dataType: 'form'
    });
  },
  createConf({ confType, k, v }) {
    let u = confType == 'r' ? '/admin/siteconf/createRedis' : '/admin/siteconf/create';
    return http.post({
      url: u,
      data: {
        key: k,
        value: v
      },
      dataType: 'form'
    });
  },

  refreshConfigByKey(key) {
    return http.post({
      url : '/admin/siteconf/refresh',
      data : { key : key},
      dataType: 'form'
    })
  },

  removeConfigByKey(key) {
    return http.post({
      url : '/admin/siteconf/remove',
      data : { key : key},
      dataType: 'form'
    })
  }
};
